"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AppBar;
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
const Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
const clsx_1 = __importDefault(require("clsx"));
const Image_1 = __importDefault(require("../Image"));
const variables_1 = __importDefault(require("../../styles/variables"));
const react_router_dom_1 = require("react-router-dom");
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Icon_1 = require("../Icon");
const Navigation_1 = require("./Navigation");
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: variables_1.default.colors.base.white,
        maxHeight: '80px',
        overflow: 'hidden', // Otherwise sidebar items are not clickable in Safari
    },
    appBarContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flex: 1,
        color: variables_1.default.colors.text.subdued,
    },
    logo: {
        '& img': {
            maxWidth: '150px',
        },
        display: 'flex',
        margin: '7px',
    },
    userContent: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        color: variables_1.default.colors.text.default,
    },
    contextChooser: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingLeft: '15px',
    },
    sideMenuButton: {
        display: 'none',
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
        },
    },
}));
function AppBar({ logoUrl, logoAltText, logoRedirect, userContent, className = undefined, contextChooser, }) {
    const classes = useStyles();
    const navigationContext = (0, react_1.useContext)(Navigation_1.Navigation.Context);
    return (react_1.default.createElement(AppBar_1.default, { variant: "outlined", position: "fixed", className: (0, clsx_1.default)(classes.appBar, className) },
        react_1.default.createElement(Toolbar_1.default, null,
            react_1.default.createElement("div", { className: classes.appBarContent },
                react_1.default.createElement(IconButton_1.default, { color: "inherit", "aria-label": "side menu", className: (0, clsx_1.default)(classes.sideMenuButton), onClick: navigationContext.toggleDrawer, "data-testid": "sideMenuIcon" }, navigationContext.isDrawerOpen ? (react_1.default.createElement(Icon_1.RegularIcon, { icon: "close" })) : (react_1.default.createElement(Icon_1.RegularIcon, { icon: "menu" }))),
                react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.logo) },
                    react_1.default.createElement(react_router_dom_1.NavLink, { to: logoRedirect },
                        react_1.default.createElement(Image_1.default, { "data-testid": "logoImage", src: logoUrl, alt: logoAltText })),
                    !!contextChooser && (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.contextChooser) }, contextChooser))),
                !!userContent && (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.userContent) }, userContent))))));
}
